/* @flow */
import v4 from 'uuid/v4';
// TODO get rid of this unproductive abstraction
export default v4;
